import React, {useEffect, useState} from "react";
import {Text, View} from "react-native-web-ui-components";
import {connect} from "react-redux";
import {ImageBackground, StyleSheet} from "react-native";
import {useDimensions} from "react-native-responsive-ui/src";
import Button from "../components/Button";
import BookSlider from "../components/BookSlider";
import axios from "axios";

const introImage = { uri: require('../assets/images/ylemine_jan_025.webp') }
const footerImage = { uri: require('../assets/images/alumine_jan.webp') }

function LandingScreen(props) {
    const date = new Date()
    const isTestPeriodOver = date.getFullYear() > 2020 || date.getMonth() > 8
    const styles = useStylesheet()
    const [sliders, setSliders] = useState(undefined);

    const fetchSliders = async () => {
        const res = await axios.get(`${(process.env.API2_URL)}/sliders`);
        setSliders(res.data);
    }

    useEffect(() => {
        fetchSliders();
    }, [])

    return (
        <View style={styles.container}>
            <ImageBackground source={introImage} style={styles.introImage}>
                <View style={styles.intro}>
                    <Text style={styles.introTitle}>{props.introTitle}</Text>
                    <Text style={styles.introContent}>
                        {props.introContent}
                    </Text>
                    <View style={styles.introLinksContainer}>
                        <Button style={styles.introButton} to="https://www.storytel.com/ee" blank external>Liitu Storyteliga</Button>
                    </View>
                    <Text style={styles.introSubText}>
                        {isTestPeriodOver ? '' : '* Testperioodi lõpuni 30.09.2020!'}
                    </Text>
                </View>
            </ImageBackground>

            <View style={styles.promo}>
                <Text style={styles.promoTitle}>{props.promoTitle}</Text>
                <Text style={styles.promoContent}>{props.promoContent}</Text>
                {sliders !== undefined && sliders.filter(slider => slider.type === "book").map(slider => (
                  <View style={styles.gallery} key={slider.id}>
                      <View style={styles.galleryTitle}>
                          <Text style={styles.galleryTitleText}>{slider.label}</Text>
                      </View>
                      <BookSlider
                        books={slider.bookIds.map(bookId => props.books.find(book => book.id === bookId)).filter(book => book !== undefined)}
                      />
                  </View>
                ))}
            </View>

            <ImageBackground source={footerImage} style={styles.footerImage}>
                <View style={styles.footer}>
                    <Text style={styles.footerTitle}>{props.footerTitle}{isTestPeriodOver ? '' : '*'}</Text>
                    <Text style={styles.footerContent}>
                        {props.footerContent}
                    </Text>
                    <View style={styles.footerButtonContainer}>
                        <Button style={styles.introButton} to="/registreerumine">kuula veebist</Button>
                        <Button
                          to="https://play.google.com/store/apps/details?id=ee.digiread.app"
                          style={styles.introButton}
                          blank
                          external
                        >
                            kuula äpist
                        </Button>
                        <Button
                            to="https://apps.apple.com/us/app/digiread/id1570619175"
                            style={styles.introButton}
                            blank
                            external
                        >
                            kuula ios äpist
                        </Button>
                    </View>
                    <Text style={styles.introSubText}>
                        {isTestPeriodOver ? '' : '* Testperioodi lõpuni 30.09.2020!'}
                    </Text>
                </View>
                </ImageBackground>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        introTitle: state.blocks.intro.title,
        introContent: state.blocks.intro.content,
        promoTitle: state.blocks.promo.title,
        promoContent: state.blocks.promo.content,
        footerTitle: state.blocks.footer.title,
        footerContent: state.blocks.footer.content,
        books: state.products.filter(book => !book.hasOwnProperty('isVisible') || book.isVisible),
    }
}

export default connect(mapStateToProps, null)(LandingScreen);

const useStylesheet = () => {
    const {width} = useDimensions()
    const isSmall = width < 500

    return StyleSheet.create({
        introButton: {
            flexGrow: 1,
            marginHorizontal: 5,
            textAlign: isSmall ? "center" : null,
            width: isSmall ? "30vh" : null,
            marginTop: isSmall ? "2vh" : null,
        },
        container: {
            flex: 1,
            backgroundColor: '#fff',
        },
        intro: {
            paddingHorizontal: '10%',
            paddingVertical: '5%',
            backgroundColor: 'rgba(0,0,0,0.4)',
        },
        introImage: {

        },
        introTitle: {
            fontSize: isSmall ? 50 : 70,
            lineHeight: isSmall ? 50 : 70,
            fontFamily: 'Aino-Headline',
            color: '#fff',
        },
        introContent: {
            color: '#fff',
            fontSize: 18,
            fontFamily: 'Aino-Regular',
            paddingTop: 150,
            paddingBottom: 20,
        },
        introLinksContainer: {
            alignItems: isSmall ? 'center' : 'flex-end',
            justifyContent: 'flex-start',
            flexDirection: isSmall ? null : 'row',
        },
        introSubText: {
            marginTop: 20,
            marginBottom: 20,
            color: 'white',
        },
        promoBackground: {

        },
        promo: {
            paddingHorizontal: '5%',
            paddingTop: '5%',
            alignItems: 'center',
            justifyContent: 'center',
        },
        promoTitle: {
            fontSize: 48,
            lineHeight: 56,
            fontFamily: 'Aino-Headline',
            color: 'rgb(37, 37, 37)',
            width: 'auto',
            paddingHorizontal: 0,
            paddingVertical: '2vh',
            textAlign: 'center',
        },
        promoContent: {
            width: 'auto',
            textAlign: 'center',
            fontSize: 19,
            lineHeight: 24,
            fontFamily: 'Aino-Regular',
            paddingVertical: '2vh',
            color: 'rgb(37, 37, 37)',
        },
        gallery: {
            width: '100%',
            paddingHorizontal: isSmall ? 25 : 50,
            paddingBottom: 50,
        },
        galleryTitle: {
            //marginHorizontal: 10,
            //marginLeft: 0,
            flexDirection: 'row',
            alignSelf: 'flex-start',
            marginBottom: 20,
            borderWidth: 0,
            borderRadius: 2,
            paddingVertical: '.35em',
            //paddingHorizontal: '1.2em',
            backgroundColor: 'transparent',

        },
        galleryTitleText: {
            fontSize: 18,
            fontFamily: 'Aino-Bold',
            color: 'rgb(37, 37, 37)',
            textTransform: 'uppercase',
        },
        footerImage: {

        },
        footer: {
            paddingHorizontal: '6%',
            paddingVertical: '5%',
            backgroundColor: 'rgba(0,0,0,0.2)',
        },
        footerTitle: {
            fontSize: 50,
            lineHeight: 50,
            fontFamily: 'Aino-Headline',
            color: '#fff',
            textAlign: 'center',
            paddingHorizontal: 50,
            paddingTop: 200,
            paddingBottom: 20,
            textShadowColor: 'rgba(0, 0, 0, 1)',
            textShadowOffset: {width: 0, height: 0},
            textShadowRadius: 3,
        },
        footerContent: {
            fontSize: 18,
            lineHeight: 18,
            fontFamily: "Aino-Regular",
            color: 'white',
            width: 'auto',
            textAlign: 'center',
            marginTop: '40px',
            marginBottom: '40px',
            textShadowColor: 'rgba(0, 0, 0, 1)',
            textShadowOffset: {width: 0, height: 0},
            textShadowRadius: 3,
        },
        footerButtonContainer: {
            display: 'flex',
            flexDirection: isSmall ? null : 'row',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: 20,
            paddingBottom: 20,
        }
    })
}
